import { FC, useCallback } from 'react';
import { ContextProviderModel } from '@/lib/models/context-provider/context-provider.model';
import { EntityLinkAction } from '../entity-link/helpers';
import useDrawer from '@/hooks/use-drawer.hook';
import { useNavigate } from '@tanstack/react-router';
import { EntityLink } from '../entity-link';

interface Props {
  context: ContextProviderModel;
  action?: EntityLinkAction;
}

const ContextProviderLink: FC<Props> = ({ context, action = 'drawer' }) => {
  const navigate = useNavigate();
  const { openDrawer } = useDrawer();
  const { id, name } = context;

  const handleClick = useCallback(() => {
    if (action === 'drawer') {
      openDrawer('context-provider', { id });
      return;
    }

    navigate({
      to: '/wais/datasources',
      search: { drawer: 'context-provider', dp_id: id },
    });
  }, [id, navigate, openDrawer, action]);

  const hasClick = action !== 'none';

  return (
    <EntityLink title={name} variant="outlined" onClick={hasClick ? handleClick : undefined} />
  );
};

export default ContextProviderLink;
